import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { processMarkdown } from '@core/tellent-assistant-util';

@Component({
  selector: 'tellent-assistant-text-part',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div class="body" [innerHTML]="html()"></div>`,
  styleUrl: './text-part.component.less',
})
export class TellentAssistantTextPartComponent {
  // plain string binding: Angular sanitizes the HTML at render time
  protected readonly html = computed(() => processMarkdown(this.content()));

  public readonly content = input.required<string>();
  public readonly done = input.required<boolean>();
}
